
/*
 * mkb-framework
 * ============================================================================
 * Index
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */
define('components/aktuelles/index',['require','exports','module','./views/module.view'],function(require, exports, module) {

	'use strict';

	module.exports = {

		Views: {

			ModuleView: require('./views/module.view')
		}
	};
});